import { createSlice, current } from '@reduxjs/toolkit';
import {
	getReportingStatusList,
	getReportingStatus,
	addNewReportingStatus,
	updateReportingStatus,
	deleteReportingStatus,
	checkReportingStatusExists,
} from './thunk';

export const initialState = {
	itemReportingStatusList: [],
	itemReportingStatus: null,
	isReportingStatusLoading: false,
	isReportingStatusSuccess: false,
	dataReportingStatus: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const ReportingStatusSlice = createSlice({
	name: 'ReportingStatus',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getReportingStatusList.pending, state => {
			state.isLoadingList = true;
			state.isReportingStatusSuccess = false;
		});

		builder.addCase(getReportingStatusList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemReportingStatusList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isReportingStatusSuccess = true;
		});

		builder.addCase(getReportingStatusList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isReportingStatusSuccess = false;
		});

		builder.addCase(getReportingStatus.pending, state => {
			state.isReportingStatusLoading = true;
			state.isReportingStatusSuccess = false;
		});

		builder.addCase(getReportingStatus.fulfilled, (state, action) => {
			state.itemReportingStatus = action.payload;
			state.isReportingStatusLoading = false;
			state.isReportingStatusSuccess = true;
		});

		builder.addCase(getReportingStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isReportingStatusLoading = false;
			state.isReportingStatusSuccess = false;
		});

		builder.addCase(addNewReportingStatus.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewReportingStatus.fulfilled, (state, action) => {
			state.itemReportingStatusList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewReportingStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateReportingStatus.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateReportingStatus.fulfilled, (state, action) => {
			state.itemReportingStatusList = state.itemReportingStatusList.map(
				reportingStatusList =>
					reportingStatusList._id.toString() === action.payload._id.toString()
						? { ...reportingStatusList, ...action.payload }
						: reportingStatusList
			);
			state.statementList = state.statementList.map(reportingStatusList =>
				reportingStatusList._id.toString() === action.payload._id.toString()
					? { ...reportingStatusList, ...action.payload }
					: reportingStatusList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateReportingStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteReportingStatus.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteReportingStatus.fulfilled, (state, action) => {
			state.itemReportingStatusList = current(
				state.itemReportingStatusList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteReportingStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkReportingStatusExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkReportingStatusExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkReportingStatusExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = ReportingStatusSlice.actions;

export default ReportingStatusSlice.reducer;
